import { connect } from "react-redux";
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import MainTemplate from "../../mainTemplate";
import Modal from "../../../utils/customModal";
import Tabs from "../../../public/tableProvider/tabs";
import { errorContainer, loadingHtml } from "../../../utils/functions";
import * as ClientActions from "../../../../Redux/actions/clientActions";

import Profile from "./profile";

export class ClientProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: {
        show: false,
        modalContent: null,
        onClose: undefined,
      },
      contentReady: false,
      activeLbl: "Perfil de la empresa",
      currentFacilities: [],
      exemptFeci: undefined
    };
  }

  componentDidMount() {
    const { modal } = this.state;
    const {
      match: { params },
      actions: { getClientByCif },
    } = this.props;

    modal.show = true;
    modal.modalContent = loadingHtml();

    this.setState({ modal: modal });

    return getClientByCif(params.clientId, params.countryCode)
      .then((client) => {
        if (
          client.data !== undefined &&
          client.data.institutionId !== undefined &&
          client.data.institutionId !== null
        ) {
          modal.show = true;
          modal.modalContent = errorContainer(
            "¡Atención!",
            "El Cliente ya está agregado en Reverse Factoring",
            { cancelBtn: { action: () => this.closeModal(), text: "Cerrar" } }
          );
          this.setState({ modal: modal });
        } else {
          this.setState({ contentReady: true });
        }
      })
      .catch((err) => {
        var title = "",
          message = "";
        switch (err.response.status) {
          case 404:
            title = "¡Error!";
            message = `El cliente con el cif ${params.clientId} no existe`;
            break;
          default:
            title = "¡Error!";
            message = `Ocurrió un error a la hora de buscar al cliente con el cif ${params.clientId}`;
            break;
        }
        modal.show = true;
        modal.modalContent = errorContainer(title, message, {
          cancelBtn: { action: () => this.closeModal(), text: "Cerrar" },
        });
        this.setState({ modal: modal });
      });
  }

  componentWillUnmount() {
    this.props.actions.clearClientByCif();
  }

  closeModal() {
    this.setState({
      modal: {
        show: false,
        modalContent: null,
        onClose: undefined,
      },
    });

    this.props.history.push(`/bscadministrator/clients/add`);
  }

  selectFacilities = (facilities) => {
    this.setState({ currentFacilities: facilities });
  };

  updateFeci = (feci) => {
    this.setState({ exemptFeci: feci });
  }

  getTabs() {
    var children = [];

    children.push(
      <div key={`profile`} label="Perfil de la empresa">
        <Profile
          key="profile"
          facilities={this.state.currentFacilities}
          updateFacilities={this.selectFacilities}
          updateFeci={this.updateFeci}
        />
      </div>
    );

    return children;
  }

  render() {
    const { modal, contentReady, activeLbl } = this.state;

    return (
      <MainTemplate>
        {contentReady ? (
          <div className="client-profile">
            <h2 className="client">
              <img
                src={`data:image/png;base64,${this.props.client.address.country.flag}`}
              />
              {`${this.props.client.name}  / 
                ${this.props.client.identification}`}
            </h2>
            <div className="header-tabs">
              <Tabs activeTab={activeLbl}>{this.getTabs()}</Tabs>
            </div>
          </div>
        ) : (
          <Modal show={modal.show} handleClose={modal.onClose}>
            {modal.modalContent}
          </Modal>
        )}
      </MainTemplate>
    );
  }
}

export const mapState = (state) => ({
  client: state.clientReducer.client,
});

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(ClientActions, dispatch),
  };
};

export default connect(
  mapState,
  mapDispatch
)(ClientProfile);
